import StepForm from '@components/StepForm'

// StoreLayout now provides FormProvider and PurchaseFlowProvider
// These components just render StepForm
export default function StoreForm() {
  return <StepForm />
}

export function MockUpForm() {
  return <StepForm />
}

